import { render, staticRenderFns } from "./news-gallery.vue?vue&type=template&id=3276512e&scoped=true"
import script from "./news-gallery.vue?vue&type=script&lang=js"
export * from "./news-gallery.vue?vue&type=script&lang=js"
import style0 from "./news-gallery.vue?vue&type=style&index=0&id=3276512e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3276512e",
  null
  
)

export default component.exports